import Button from "@src/components/UIElements/Button";
import styles from "./RetryPayment.module.scss";
import Image from "@src/lib/Image";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { handleRetryOption } from "@src/PaymentService";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { EVENTS_NAME_MAPPING } from "@src/utils/constants";
import { useSelector } from "react-redux";

function RetryPayment({ data = {} }) {
  const userDetails = useSelector(
    (state) => state?.overviewReducer?.userDetails?.responseData?.user
  );
  let orgDetails = useSelector((state) => {
      return state?.persistedDataReducer?.orgDetails?.organization;
  });
  const {
    heading,
    subheading1,
    headingColor,
    subheadingColor,
    isPaymentFailed,
    bgImageUrl,
    isPaymentProcessing,
    orderId,
    deeplink,
  } = data;
  if(!heading || !subheading1){
    return null
  }
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.headingContainer}>
        <p
          className={styles.heading}
          style={{ ...(headingColor && { color: headingColor }) }}
        >
          {heading}
        </p>
        <p style={{ ...(subheadingColor && { color: subheadingColor }) }}>
          {subheading1}
        </p>
      </div>
      <div className={styles.btnGroup}>
        <button
          onClick={() => handleRetryOption(orderId)}
        >
          Retry Payment
        </button>
        <button
          className={styles.retryBtn}
          outline
          onClick={() => {
            hitDeeplinkExecutedV2(
              JSON.stringify(deeplink),
              JSON.stringify(deeplink)
            )
          
            newWebEngage(EVENTS_NAME_MAPPING.contactSupport, {
              org_id: orgDetails?.id + "",
              cp_user_id: Number(userDetails?.id),
              date_and_time: new Date(),
            });
          }
          }
        >
          Contact Support
        </button>
      </div>
      <picture className={styles.alertImage}>
        <Image
          src={bgImageUrl}
          height={"100%"}
          width={"100%"}
          objectFit="contain"
          layout="fill"
        />
      </picture>
    </div>
  );
}

export default RetryPayment;
